import { endpointConstants } from "../constants";
import { get } from "../../utils";

export const yodaBudgetService = {
  getBudget,
};

function getBudget(customerId, seasonCode, lineCode) {
  let endpoint = endpointConstants.YODABUDGET.GET_BUDGET.replace(
    ":customerId",
    customerId,
  ) // "13399"
    .replace(":seasonId", seasonCode) // "23122"
    .replace(":lineId", lineCode); // "23122"

  return get(endpoint);
}
